import { render, staticRenderFns } from "./KundeMedia.vue?vue&type=template&id=45e77ec3&"
import script from "./KundeMedia.vue?vue&type=script&lang=js&"
export * from "./KundeMedia.vue?vue&type=script&lang=js&"
import style0 from "./KundeMedia.vue?vue&type=style&index=0&id=45e77ec3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports